import React, { useState, useEffect } from 'react';
import Web3 from 'web3';
import './StakeWalletBalance.css'; // Pretpostavljamo da imate ovaj CSS fajl

// Web3 inicijalizacija i token konfiguracija
const web3 = new Web3(Web3.givenProvider || "https://bsc-dataseed1.binance.org:443");
const tokenABI = [
  {
    constant: true,
    inputs: [{ internalType: "address", name: "account", type: "address" }],
    name: "balanceOf",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    payable: false,
    stateMutability: "view",
    type: "function",
  },
  // Ovdje dodajte ostatak vašeg ABI-ja ako je potrebno
];
const tokenAddress = '0x7c59a57fc16eac270421b74615c4bc009ecd486d';
const stakewalletAddress = '0xF579821470738BC4d41C0A366489c0b7e011900C';

function StakeWalletBalance() {
  const [balance, setBalance] = useState('');

  async function getBalance() {
    try {
      const tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
      const balanceWei = await tokenContract.methods.balanceOf(stakewalletAddress).call();
      const balanceInEth = web3.utils.fromWei(balanceWei, 'ether');
      setBalance(balanceInEth);
    } catch (error) {
      console.error("Error fetching balance: ", error);
      setBalance('Error'); // Prikazuje "Error" u interfejsu u slučaju problema
    }
  }

  useEffect(() => {
    getBalance();
    const intervalId = setInterval(getBalance, 600000); // Ažurira saldo svakih 10 minuta
    return () => clearInterval(intervalId);
  }, []);

  // Konfigurisanje NumberFormat-a
  const formattedBalance = balance ? new Intl.NumberFormat('de-DE', { 
    minimumFractionDigits: 0, 
    maximumFractionDigits: 0 
  }).format(balance) : 'Loading...';

  return (
    <div className="stake-balance-container d-flex justify-content-center align-items-center">
      <span className="stake-title">Staked:</span>
      <span className="stake-balance">{formattedBalance} RXCG</span>
      <a href={`https://bscscan.com/address/${stakewalletAddress}`} 
         target="_blank" 
         rel="noopener noreferrer" 
         className="stake-verify-link btn btn-link">Verify</a>
    </div>
  );
}

export default StakeWalletBalance;
